import api from './api'
import { API_ENDPOINTS } from '../config/api'

// Auto Void — owner-only. Har endpoint par server requireOwner lagata hai
// (routes/admin/bettingConfigRoutes.js). Timer khud results cron chalata hai
// (server/sportsbet/betresult/autoVoid.js); ye page sirf setting aur tracker hai.
const autoVoidService = {
  // { enabled, delay_seconds, on_match_odds, on_bookmaker, min_delay_seconds, max_delay_seconds }
  getConfig: async () => {
    const response = await api.get(API_ENDPOINTS.AUTO_VOID.CONFIG)
    return response.data
  },
  saveConfig: async (payload) => {
    const response = await api.put(API_ENDPOINTS.AUTO_VOID.CONFIG, payload)
    return response.data
  },
  // { enabled, delay_seconds, server_time, events: [{ eventid, match_title, sport_name, anchor_market, fire_at, markets: [...] }] }
  getPending: async () => {
    const response = await api.get(API_ENDPOINTS.AUTO_VOID.PENDING)
    return response.data
  },
  getLinks: async () => {
    const response = await api.get(API_ENDPOINTS.AUTO_VOID.LINKS)
    return response.data
  },
  // { name, url, sport_id (null = all), sort_order, active }
  createLink: async (payload) => {
    const response = await api.post(API_ENDPOINTS.AUTO_VOID.LINKS, payload)
    return response.data
  },
  updateLink: async (id, payload) => {
    const response = await api.put(`${API_ENDPOINTS.AUTO_VOID.LINKS}/${id}`, payload)
    return response.data
  },
  deleteLink: async (id) => {
    const response = await api.delete(`${API_ENDPOINTS.AUTO_VOID.LINKS}/${id}`)
    return response.data
  },
}

export default autoVoidService
